import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Autocomplete,
    TextField,
    Box,
    IconButton,
    FormControl,
    Stack,
    Grid,
    Typography,
    TablePagination,
    Popover,
    Checkbox,
} from "@mui/material";
import { filterOptions } from "../../../global/constants/globalContants.ts";
import DeleteIcon from "@mui/icons-material/Delete";
import { ApideleteAirTasker, ApiExportWithoutReportShopperList, ApiGetShopperList, ApiGetWithoutReportShopperList, ApiupdateAirTaskerStatus } from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { useShopperDetails } from "../../../global/ShopperDetailsUtils.ts";
import Dcrage from "../OrphanAllocation/Dcrage.tsx";
const DShopper: React.FC = () => {
    const navigate = useNavigate();
    // const addOrUpdateairtasker = (airtasker: any) {
    //     if (airtasker.userId) {
    //         navigate('')
    //     }
    // }
    const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();
    const [shoppersList, setShoppersList] = useState<any>([])
    const [selectedFilter, setSelectedFilter] = useState<any>(null)
    const [datalength, setdatalength] = useState<any>(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchShopper, setsearchShopper] = useState<any>([])
    const [selected, setSelected] = useState<any[]>([]);
    const handleGetApiCall = async (status?: string) => {
        try {
            // const filterStatus = status || selectedFilter?.value || "active"
            const data = `?page=${page + 1}&limit=${rowsPerPage}${searchShopper.length > 0 ? `&search=${searchShopper}` : ''}`
            const res = await ApiGetWithoutReportShopperList(data)
            setdatalength(res?.total)
            setShoppersList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }

    const handleFilterChange = async (event: any, newValue: any) => {
        setSelectedFilter(newValue)
        setPage(0)
        if (newValue) {
            await handleGetApiCall(newValue.value)
        }
    }
    const deleteAirTasker = async (user: any) => {
        const data = {
            userId: user.userId,
        };
        try {
            const response: any = await ApideleteAirTasker(data);
            toast.success("AirTasker deleted successfully!");
            handleGetApiCall();
        } catch (error) {
            console.error("Error during API call:", error);
            toast.error("Failed to delete AirTasker");
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            const defaultFilter = filterOptions[0]
            setSelectedFilter(defaultFilter)
            await handleGetApiCall(defaultFilter.value)
        }
        fetchData()
        return () => { }
    }, [rowsPerPage, page, searchShopper])


    // const currentShoppers = shoppersList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    const currentShoppers = shoppersList

    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const DownloadExcel = async () => {
        try {
            const res = await ApiExportWithoutReportShopperList();

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Active_Shoppers_Without_Report.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert(error)
        }
    }

    const isSelected = (id: string) => selected.indexOf(id) !== -1;

    console.log("Sleected Roww----->", selected)
    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const newSelected = currentShoppers.map((n: any) => n.userId);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleCheckboxClick = (id: string) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected: string[] = [];

        if (selectedIndex === -1) {
            newSelected = [...selected, id];
        } else {
            newSelected = selected.filter((item) => item !== id);
        }

        setSelected(newSelected);
    };
    return (
        <Box className="w-100 p-2">
            <Box className='bg-light border-10 p-2'>
                <Grid container className=" mb-4 mt-3 align-items-center justify-content-between" gap={3}>
                    <Grid size={{ xs: 12, md: "auto" }} order={{ xs: 2, md: 2 }}>
                        <FormControl>
                            {/* <InputLabel>Search Shopper</InputLabel> */}
                            <TextField value={searchShopper} label="Search Shopper" onChange={(e) => { setsearchShopper(e.target.value) }} />
                        </FormControl>
                    </Grid>
                    <Grid size={{ xs: 12 }} order={{ xs: 1, md: 1 }}>
                        <Typography className="text-center fs-42">Dormant Shoppers</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: "auto" }} order={{ xs: 3, md: 3 }}>
                        <Button
                            variant="contained"
                            onClick={() => { DownloadExcel() }}
                            className="table-row-background py-2"
                        >
                            Export as Excel
                        </Button>
                    </Grid>
                </Grid>
                <Box className='w-100' overflow={'auto'}>
                    <Table>
                        <TableHead>
                            <TableRow className="table-row-background">
                                <TableCell padding="checkbox">
                                    <Checkbox
                                        color="primary"
                                        indeterminate={
                                            selected.length > 0 && selected.length < currentShoppers.length
                                        }
                                        checked={
                                            currentShoppers.length > 0 &&
                                            selected.length === currentShoppers.length
                                        }
                                        onChange={handleSelectAllClick}
                                    />
                                </TableCell>

                                {["First Name", "Last Name", "Email ID", "Mobile No", "", ""].map(
                                    (item) => (
                                        <TableCell key={item} style={{ color: "#fff" }}>
                                            {item}
                                        </TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {currentShoppers?.map((user: any) => {
                                const checked = selected?.includes(user?.userId);
                                return (
                                    <TableRow key={user.userId}
                                        role="checkbox"
                                        selected={checked}
                                    >
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                color="primary"
                                                checked={checked}
                                                onChange={() => handleCheckboxClick(user.userId)}
                                            />
                                        </TableCell>
                                        <TableCell>{user.firstName}</TableCell>
                                        <TableCell>{user.lastName}</TableCell>
                                        <TableCell>{user.emailId}</TableCell>
                                        <TableCell>{user.contactNo}</TableCell>
                                        <TableCell>
                                            <Button
                                                variant="contained" onClick={(e) => handleShopperDetailsClick(e, user.userId)}
                                                className="table-row-background"
                                            >
                                                View
                                            </Button>
                                        </TableCell>
                                        {/* <TableCell>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        navigate(`/admin/shopper/update/${user.userId}`, {
                                            state: { shopperDetails: user },
                                        })
                                    }}
                                    className="table-row-background"
                                >
                                    Edit
                                </Button>
                            </TableCell> */}
                                        <TableCell>
                                            <Button
                                                variant="contained"
                                                className="delete-transparent"
                                                onClick={() => {
                                                    const isConfirmed = window.confirm(
                                                        "Are you sure you want to delete the shopper?"
                                                    );
                                                    if (isConfirmed) {
                                                        deleteAirTasker(user);
                                                    }
                                                }}>
                                                <DeleteIcon className="delete-icon" />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </Box>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={datalength}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Box>
            <Popover
                // open={Boolean(anchorEl) && selectedIndex === index}
                open={Boolean(anchorEl) && clickedShopperId !== null}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Dcrage handleClose={handleClose} loanData={loanData} />
            </Popover>
        </Box>
    )
}
export default DShopper;
